var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 84V76C80 71.7565 78.3143 67.6869 75.3137 64.6863C72.3131 61.6857 68.2435 60 64 60H32C27.7565 60 23.6869 61.6857 20.6863 64.6863C17.6857 67.6869 16 71.7565 16 76V84M64 28C64 36.8366 56.8366 44 48 44C39.1634 44 32 36.8366 32 28C32 19.1634 39.1634 12 48 12C56.8366 12 64 19.1634 64 28Z",
    stroke: "#5E6278",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLarge);
export default __webpack_public_path__ + "static/media/UserLarge.11a52b51b1c086dca4e512df5de62276.svg";
export { ForwardRef as ReactComponent };